import db from '@/services/db'

export default {
  loadComments ({ commit }) {
    db.comments.readAll(comments => {
      commit('updateComments', comments);
    })
  },
  addComment ({ commit, state }, comment) {
    db.comments.add(comment)
  }
}